export type TSubscriptionOrgMembersParams = {
  baId: string;
  subscriptionId: string;
  search: string;
};

export const subscriptionsKeys = {
  all: [{ module: 'subscriptions' }] as const,
  details: () => [{ ...subscriptionsKeys.all[0], scope: 'detail' }] as const,
  detail: (subscriptionId: string) => [{ ...subscriptionsKeys.details()[0], subscriptionId }] as const,
  memberDetail: (baId: string, subscriptionId: string) =>
    [{ ...subscriptionsKeys.detail(subscriptionId)[0], baId, access: 'member' }] as const,
  orgMembersLists: () => [{ ...subscriptionsKeys.all[0], scope: 'orgMembers' }] as const,
  orgMembersList: (params: TSubscriptionOrgMembersParams) =>
    [{ ...subscriptionsKeys.orgMembersLists()[0], params }] as const,
};
